import React from 'react';

const fmt = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);

const TerminalOutput = ({ monthlyRevenue, annualRevenue }) => {
  return (
    <div className="relative bg-[#060c1a] border border-[#00E5FF]/30 p-6 sm:p-8 rounded-lg flex flex-col h-full"
      style={{ boxShadow: '0 0 30px rgba(0,229,255,0.08), inset 0 0 30px rgba(0,229,255,0.02)' }}
    >
      {/* Terminal Header Bar */}
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-[#00E5FF]/15">
        <div className="flex items-center gap-2">
          <span className="text-[10px] tracking-widest text-slate-500 uppercase font-mono">
            revenue.terminal
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] tracking-widest text-[#00E5FF] uppercase font-mono opacity-70">Live</span>
          <div
            className="w-2 h-2 rounded-full bg-[#00E5FF] animate-pulse"
            style={{ boxShadow: '0 0 8px rgba(0,229,255,0.9)' }}
          />
        </div>
      </div>

      {/* Monthly Revenue - Hero Metric */}
      <div className="mb-8 pb-8 border-b border-[#00E5FF]/10">
        <p className="text-[10px] uppercase tracking-widest text-slate-500 mb-3 font-mono">
          Monthly Revenue
        </p>
        <div
          className="text-5xl sm:text-6xl font-mono font-bold text-[#00E5FF] tracking-tight leading-none"
          style={{ textShadow: '0 0 24px rgba(0,229,255,0.45)' }}
        >
          {fmt(monthlyRevenue)}
        </div>
        <p className="text-xs text-slate-600 mt-2 font-mono">per calendar month</p>
      </div>

      {/* Annual Run Rate */}
      <div className="mb-8 flex-1">
        <p className="text-[10px] uppercase tracking-widest text-slate-500 mb-3 font-mono">
          Annual Run Rate
        </p>
        <div className="text-3xl sm:text-4xl font-mono font-bold text-white tracking-tight">
          {fmt(annualRevenue)}
        </div>
        <p className="text-xs text-slate-600 mt-2 font-mono">12-month projection</p>
      </div>

      {/* ROI Footer */}
      <div className="mt-auto pt-6 border-t border-slate-800">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-widest text-slate-500 font-mono mb-1">
              ROI on First Client
            </p>
            <p className="text-xs text-slate-600 font-mono">$499 retail investment</p>
          </div>
          <div className="text-right">
            <span
              className="text-3xl font-oswald font-bold text-[#FF3333]"
              style={{ textShadow: '0 0 16px rgba(255,51,51,0.4)' }}
            >
              15X+
            </span>
            <p className="text-[10px] text-slate-600 font-mono mt-1">return</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminalOutput;